import { Button, NewModal } from '@platform/ui-library';
import {
  FC,
  useCallback
} from 'react';
import { useServices, useSubject } from '../hooks';
import { ErrorMessageType } from '../services';

/** Displays errors stored in @see ErrorMessageService in a modal. */
export const ErrorMessageModal: FC = () => {
  const { errorMessageService } = useServices();
  const topError = useSubject(
    errorMessageService.topErrorChange,
    errorMessageService.topError
  );

  const {
    message,
    onClose,
    title = 'An Unhandled Error Occurred',
    type = ErrorMessageType.error
  } = topError ?? {};

  const handleClose = useCallback(() => {
    errorMessageService.popError();
    onClose?.();
  }, [errorMessageService, onClose]);

  const iconClassName = (type === ErrorMessageType.warning) ? (
    'icon-alert-triangle'
  ) : 'icon-alert-octagon';
  const titleClassName = (type === ErrorMessageType.warning) ? (
    'container-warning'
  ) : 'container-error';

  // Do not use `isOpen` so we can guarantee this modal being on top.
  return (!topError) ? null : (
    <NewModal className="ui-box-medium" handleClose={handleClose} isOpen>
      <div className={`box header flex-center-start ${titleClassName}`}>
        <i className={`fe ${iconClassName}`}></i>
        {title}
      </div>
      {(message == null) ? null : (
        <div className="box content">
          {message}
        </div>
      )}
      <div className="box footer">
        <Button theme="outline" onClick={handleClose}>
          {window.l.popup.cancel}
        </Button>
      </div>
    </NewModal>
  );
};
